import { useState, useEffect } from 'react';

export default function useWindowSize() {
    const [width, setWidth] = useState(() => window.innerWidth); // ✅ Uses lazy initialization for efficiency

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // ✅ Ensures effect runs only once

    return width;
}
